/**
 * Whether this page runs in a reseller's shop (a real reseller host, window.__TC_TENANT__ set by the server)
 * or in our customer demo tab — in both cases nothing of ours may show (docs/white-label/SPEC-v1.md).
 * Set up by components/reseller/demo-sandbox/boot.ts before any component renders.
 */
interface ShopGlobals {
  __TC_WL_DEMO__?: { hidden?: string[]; shop?: boolean };
  __TC_TENANT__?: { host?: string; mode?: string; logo?: string | null; color?: string; legal?: { termsUrl?: string; privacyUrl?: string } };
}

const g = (): ShopGlobals => (typeof window === 'undefined' ? {} : (window as unknown as ShopGlobals));

/** A reseller's shop or our demo of one. */
export const isWhiteLabel = (): boolean => !!g().__TC_WL_DEMO__;

/** The reseller's website (mode "full": www.<domain>), or null. */
export function shopWebsiteUrl(): string | null {
  const t = g().__TC_TENANT__;
  if (!t?.host || t.mode !== 'full') return null;
  return `https://${t.host.replace(/^app\./, 'www.')}/`;
}

export const shopLegal = () => g().__TC_TENANT__?.legal ?? {};
export const shopLogo = () => g().__TC_TENANT__?.logo ?? null;
